// extracted by mini-css-extract-plugin
export default {"form":"kCQkKEr_","fullWidth":"r03t9Y1O","error":"b3UF8lxb"};